import { tenantApi } from '@shared/api/tenantApi';
import { unwrap, unwrapList } from '@shared/api/unwrap';

export interface MemberVehicle {
  vehicle_id: string;
  member_id: string | null;
  vehicle_type: string;
  name: string;
  registration?: string | null;
  make?: string | null;
  model?: string | null;
  colour?: string | null;
  photo_url?: string | null;
  property_location_id?: string | null;
  property_location_name?: string | null;
  created_at?: string;
}

export interface VehicleTypeOption {
  value: string;
  label: string;
}

export interface VehiclePayload {
  vehicle_type: string;
  name: string;
  registration?: string;
  make?: string;
  model?: string;
  colour?: string;
  member_id: string;
  property_location_id?: string | null;
}

export async function fetchMemberVehicles(memberId: string): Promise<MemberVehicle[]> {
  const { data } = await tenantApi.get('/vehicles', {
    params: { limit: 100, sort_by: 'name', sort_order: 'asc', member_id: memberId },
  });
  return unwrapList<MemberVehicle>(data);
}

export async function fetchActiveVehicleTypes(): Promise<VehicleTypeOption[]> {
  const { data } = await tenantApi.get('/vehicle-types/active');
  return unwrapList<VehicleTypeOption>(data);
}

export async function createVehicle(payload: VehiclePayload): Promise<MemberVehicle> {
  const { data } = await tenantApi.post('/vehicles', payload);
  return unwrap<MemberVehicle>(data);
}

export async function updateVehicle(
  vehicleId: string,
  payload: Partial<VehiclePayload>,
): Promise<MemberVehicle> {
  const { data } = await tenantApi.put(`/vehicles/${vehicleId}`, payload);
  return unwrap<MemberVehicle>(data);
}

export async function uploadVehiclePhoto(
  vehicleId: string,
  file: Blob,
): Promise<string | undefined> {
  const ext = file.type === 'image/png' ? 'png' : 'jpg';
  const formData = new FormData();
  formData.append('file', file, file instanceof File ? file.name : `vehicle.${ext}`);
  const { data } = await tenantApi.post(
    `/vehicles/${vehicleId}/photo`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
  return unwrap<{ photo_url?: string }>(data).photo_url;
}

export async function deleteVehicle(vehicleId: string): Promise<void> {
  await tenantApi.delete(`/vehicles/${vehicleId}`);
}
